import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "ServeError",
  components: {},
  props: ["prorData"],
  data: function data() {
    // 验证地址
    var urlVerify = function urlVerify(rule, value, callback) {
      var reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~/])+$/i.test(value);

      if (!reg) {
        callback(new Error("请输入正确地址！"));
        return;
      }

      callback();
    };

    return {
      baseUrl: process.env.BASE_URL,
      form: {
        serveId: "",
        //
        formType: "three",
        // 用于局别三种类型
        name: "",
        // 服务名称
        obj: [],
        // 服务对象
        theme: [],
        // 主题
        recommend: false,
        // 是否推荐  不推荐：0，推荐：1
        imgUrl: "",
        // 服务图标
        imgId: "",
        // 上传之后的Id
        processDefId: "",
        // 服务Id
        processVersionId: "",
        // 流程版本Id
        linkUrl: "",
        // 站外链接
        mobileUrl: "",
        terminal: []
      },
      uploadUrl: this.$http.defaults.baseURL + "/serveFile/upload",
      // 上传地址
      uploadHeader: {},
      // 上传接口header设置
      rules: {
        obj: [{
          required: true,
          message: "请选择服务对象",
          trigger: "blur"
        }],
        theme: [{
          required: true,
          message: "请选择服务主题",
          trigger: "blur"
        }],
        name: [{
          required: true,
          message: "请入服务名称",
          trigger: "blur"
        }],
        imgUrl: [{
          required: true,
          message: "请选择服务图标",
          trigger: "blur"
        }],
        linkUrl: [{
          required: true,
          message: "请输入PC端链接",
          trigger: "blur"
        }],
        mobileUrl: [{
          required: true,
          message: "请输入手机端链接",
          trigger: "blur"
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    // 默认判断，有详情值的话，回显；
    initFn: function initFn() {
      var _this = this;

      if (JSON.stringify(this.prorData.infoFrom) !== "{}") {
        var data = this.prorData.infoFrom;
        this.form.serveId = data.serveId;
        this.form.formType = data.formType; // 用于局别三种类型

        this.form.name = data.name; // 服务名称

        this.form.obj = data.obj; // 服务对象

        this.form.theme = data.theme; // 主题

        this.form.recommend = data.recommend; // 是否推荐

        this.form.imgUrl = data.imgUrl; // 服务图标

        this.form.imgId = data.imgId; // 图标Id

        this.form.processDefId = data.processDefId; // 服务Id

        this.form.processVersionId = data.processVersionId; // 流程版本Id

        this.form.linkUrl = data.linkUrl; // 站外链接

        this.form.mobileUrl = data.mobileUrl;
        this.form.terminal = data.terminal.split(",");
      } else {
        this.$nextTick(function () {
          _this.form.terminal = ["pc", "mobile"];
        });
      }
    },
    // 验证 在上一个组件调用，并 return form的值回上个组件(Dialog.vue)
    validateForm: function validateForm(formName) {
      var _this2 = this;

      // 验证
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          // 过滤默认空数据
          _this2.form.terminal = _this2.form.terminal.filter(function (item) {
            return item !== "";
          }); // 如果还存在图片id、则不用再跑上传流程

          if (_this2.form.imgId === "") {
            // 提交的时候上传文件
            _this2.$refs.upload.submit();
          } else {
            _this2.$emit("backFn", _this2.form);
          }
        }
      });
    },
    // 选中图片(用于选中未提交时，显示图片)
    // 选中的时候、验证图片格式、大小
    // 设置 请求 header
    // 设置 图片选择框中显示图标
    onChange: function onChange(file) {
      var arr = [];
      var isPNG = file.raw.type === "image/png";
      var isLt2M = file.size / 1024 < 21;

      if (!isPNG) {
        this.form.imgUrl = "";
        this.$message.error("上传服务图标只能是 PNG 格式!");
        return;
      }

      if (!isLt2M) {
        this.form.imgUrl = "";
        this.$message.error("上传服务图标大小不能超过 20KB!,请重新上传。");
        return;
      } // 变更图标之后重新赋值，保持只有有个图标


      arr.push(file);
      this.$refs.upload.uploadFiles = arr;
      this.form.imgId = ""; // 选择新图片，id要为空

      this.uploadHeader = {
        token: this.userToken,
        Authorization: "bearer " + this.$keycloak.token
      }; // 设置上传的 headers token

      this.form.imgUrl = URL.createObjectURL(file.raw);
    },
    // 上传成功
    // 上传成功之后、设置 已上传图标的id;
    onSuccess: function onSuccess(response) {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.form.imgId = response.resData[0];

        _this3.$emit("backFn", _this3.form);
      });
    },
    // 上传错误
    onError: function onError() {
      var _this4 = this;

      this.$message.error("图标上传错误！");
      this.$nextTick(function () {
        _this4.form.imgUrl = "";
      });
    }
  },
  watch: {
    prorData: {
      handler: function handler() {
        this.initFn();
      },
      immediate: true
    }
  },
  filters: {}
};